import Loading from "../../../assets/gif/Loading.gif";
import { LoadingOutlined } from "@ant-design/icons";
import "../../../assets/css/commonVessels.css";
import "../../../assets/css/conversationPage.css";

export const CommonLoading = () => {
    return (
        <div className="container-loading">
            <img
                src={Loading}
                alt="loading"
                style={{
                    height: 150,
                    width: 200,
                    mixBlendMode: "darken",
                    pointerEvents: "none",
                }}
            />
        </div>
    );
};

export const CommonSpinLoading = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "61vh", // Full viewport height
            }}
        >
            <LoadingOutlined
                data-cy="common-loading-spinner"
                spin
                style={{
                    fontSize: 24,
                    color: "#605BFF",
                }}
            />
        </div>
    );
};

export const ConversationListSkeletonLoading = () => {
    return (
        <div className="w-auto overflow-hidden mt-1">
            {Array.from({ length: 20 }).map((_, index) => (
                <div key={index} className="d-flex align-items-start px-1 py-3">
                    <div className="chat-avatar-skeleton ms-2 my-1"></div>

                    <div className="ms-2 rounded-3 flex-grow-1">
                        <div className="chat-line-skeleton my-2 w-75"></div>
                        <div className="chat-line-skeleton w-50"></div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export const CommonLoadingV2 = () => {
    return (
        <div
            data-cy="initial-common-loading-spinner"
            className="loading d-flex justify-content-center align-items-center"
        >
            <span />
            <span />
            <span />
        </div>
    );
};
